import Immutable from 'immutable';
import React, { ReactElement } from 'react';
import { Doc } from 'records/Doc';
import { Page } from 'records/Page';
import { SelectedApprovedFiles, Submittal } from 'records/Submittal';
import ApprovedFile from './ApprovedFile';

interface SubWithDoc {
  sub: Submittal;
  doc: Doc;
  firstPage: Page;
}

const ApprovedFileRenderer = (
  style: React.CSSProperties,
  index: number,
  data: Immutable.OrderedMap<string, SubWithDoc>,
  selectedApprovedFiles: SelectedApprovedFiles,
  onDocThumbnailClick: (doc: Doc, submittal: Submittal) => void,
  onCheckboxChange: (checked: boolean, docId: string) => void
): ReactElement => {
  const file = data.valueSeq().get(index);

  return file ? (
    <ApprovedFile
      style={style}
      key={file?.doc.documentid || ''}
      submittal={file.sub}
      document={file.doc}
      firstPage={file.firstPage}
      onDocThumbnailClick={() => onDocThumbnailClick}
      onCheckboxChange={() => onCheckboxChange}
      selectedFiles={selectedApprovedFiles}
    />
  ) : (
    <div />
  );
};

export default ApprovedFileRenderer;
